"use strict";
const surveySelector = '.js-cancellation_survey';
const answerInputSelector = '.js-cancellation_survey_answer';
// The survey sits above both cancellation forms so it can never obstruct them,
// so the answer has to be copied into every form that could be submitted.
window.up.compiler(surveySelector, (survey) => {
    window.up.on(survey, 'change', undefined, (_event, radio) => {
        document.querySelectorAll(answerInputSelector).forEach(input => (input.value = radio.value));
    });
});
